import React from 'react';
import { useDispatch } from 'react-redux';
import { Product } from 'services/action';
import { Page } from 'ui/components';
import {
  Action,
  SectionUnit,
  SectionProduct,
} from './component/detail';

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const [data, setData] = React.useState();

  const $onLoad = async (id) => {
    const req = await Dispatch(Product.$show(id));

    if (req?.message === 'success') {
      setData(req?.data);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page className="bg-white">
      <Page.Header title="Detil Item" />

      <Page.Navigation toolbar>
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Navigation>

      <Page.Body className="d-block px-3 py-4">
        <div className="row ">
          <div className="col-md-6">
            <SectionProduct data={data} />
          </div>
          <div className="col-md-6">
            <SectionUnit data={data?.units} />
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
